import { useMemo } from 'react';

import type { Freelancer } from 'state/__generated__/tadaahAPI';
import { useApiFreelancerRead } from 'state/__generated__/tadaahAPI';

import useIsFreelancerLoggedIn from 'hooks/use-is-freelancer-logged-in';

type UseGetFreelancerDetailsHandler = {
  data: Freelancer | undefined;
  error: string | undefined;
  isLoading: boolean;
  isSuccess: boolean;
  competencesArray: string[] | undefined;
};

export const useGetFreelancerDetails = (): UseGetFreelancerDetailsHandler => {
  const isLoggedIn = useIsFreelancerLoggedIn();

  const { data, error, isLoading, isSuccess } = useApiFreelancerRead({
    query: {
      enabled: isLoggedIn,
      queryKey: 'freelancer-details',
    },
  });

  const competencesArray: string[] | undefined = useMemo(() => {
    if (data?.data?.competences)
      return Object.keys(data?.data.competences).filter(
        (key) => data?.data?.competences?.[key] === true,
      );
    return [];
  }, [data?.data.competences]);

  return {
    competencesArray,
    data: data?.data,
    error: error?.message,
    isLoading,
    isSuccess,
  };
};

export default useGetFreelancerDetails;
